import {EntrySummary} from 'notebook/ELNConstants';

export enum ExistingEntryActionType {
  SET_SELECTED_ENTRY = 'EXECUTE_REQUEST_FLOW_EXISTING_ENTRY_SET_SELECTED_ENTRY',
}

interface SetSelectedEntryAction {
  selectedEntry: EntrySummary | null;
  type: ExistingEntryActionType.SET_SELECTED_ENTRY;
}

export function setSelectedEntry(selectedEntry: EntrySummary | null): SetSelectedEntryAction {
  return {
    type: ExistingEntryActionType.SET_SELECTED_ENTRY,
    selectedEntry,
  };
}

export type ExistingEntryAction = SetSelectedEntryAction;
